/*
自分のデータをどうやって取得するのが良いのか話し合う
*/
import { setting } from './lib/_setting.js';
import { load } from './lib/_load.js';
import { loc } from './lib/_location.js';
import { common } from './_common.js';
import { home } from './_top.js';
import { collection } from './_collection.js';
import { report } from './_report.js';

let $html = document.documentElement;

let isDebug = false;

export class Framework {
	constructor(){
		this.isLogin 	= false;
		this.isEntry 	= false;
		this.firstVisit = true;
		this.canClick 	= true;
		this.pageinfo = loc.all();
		this.nextpage = "";
		
		this.checkLoginStatus().then( ()=> {
			this.startPage();
		});
		this.nav();
	}
	nav(){
		let $this = this;
		let count = 0;
		let $modeBtn = document.querySelector("a#btn_mode");
		if($modeBtn){
			$modeBtn.addEventListener("click", function(){
				count++;
				if(count > 2){
					count = 0;
				}
				if(count === 0){
					setting.isLogin 	= 0;
					setting.isEntried 	= 0;
				}else if(count === 1){
					setting.isLogin 	= 1;
					setting.isEntried 	= 0;
				}else if(count === 2){
					setting.isLogin 	= 1;
					setting.isEntried 	= 1;
				}
				let $body = document.querySelector("body");
				$body.classList.remove("no_login");
				$body.classList.remove("no_entry");
				$body.classList.remove("entried");
				$body.classList.remove("login");
				$this.setLoginStatus("");
				window.scrollTo(0, 0);
				$this.startPage();
			}, false);
		}
	}
	checkLoginStatus(){
		let $this = this;
		return new Promise((resolve, reject) => {
			//console.log(setting.loginStatus);
			load.getJson(setting.loginStatus, {}).then( (res) => {
				console.log(res.data);
				setting.isLogin 	= res.data.result;
				setting.isEntried 	= res.data.listenplus_entry;
				$this.setLoginStatus(res.data);
				resolve();
			});
		});
	}
	setLoginStatus(data){
		let $this = this;
		let $body = document.querySelector("body");
		//console.log("Login Status: ", data);
		//setting.isConnected = data.;
		//
		//
		if(isDebug){
			setting.isLogin 	= 1;
			setting.isEntried 	= 1;
		}else{
			setting.isLogin 	= data.result;
			setting.isEntried 	= data.listenplus_entry;
		}
		console.log("isLogin:", setting.isLogin, "isEntried:", setting.isEntried);
		let page = this.pageinfo.pathArry[4];
		if(page === ""){
			if(setting.isLogin === 0){ //J-me未ログイン
				$this.isLogin = false;
				$body.classList.add("no_login");
				$body.classList.add("no_entry");
				showPage();
			}else{ //J-meログイン済み
				$this.isLogin = true;
				$body.classList.add("login");
				if(setting.isEntried === 1){ //参加済み
					$this.isEntry = true;
					$body.classList.add("entried");
				}else{ //未参加
					$this.isEntry = false;
					$body.classList.add("no_entry");
					showPage();
				}
			}
			let page = this.pageinfo.pathArry[4];
			this.checkLogedIn(page);
			
			//console.log(page);
			if(page === ""){ //top
			
			}else{
				showPage();
			}
		}
		function showPage(){
			if( $body.classList.contains("disable") ){
				$body.classList.remove("disable");
			}
		}
	}
	startPage(){
		let t = this;
		if(this.firstVisit){
			this.firstVisit = false;
			common.init();
		}
		let page = this.pageinfo.pathArry[4];
		this.checkLogedIn(page);
		
		//console.log(page);
		if(page === ""){ //top
			home.init();
		}else if(page === "collection"){
			if(!setting.isEntried){
				location.href = "/jlc/listenplus/app/";
			}else{
				if(t.pageinfo.pathArry[t.pageinfo.pathArry.length - 1] === "connected.html"){
					document.querySelector("body").classList.remove("disable");
				}else{
					collection.init(this.pageinfo);
				}
			}
		}else if(page === "report"){
			if(this.pageinfo.pathArry.length > 6){
				if(this.pageinfo.pathArry[5] === "history"){
					report.init("history");
				}
			}else{
				report.init("report");
			}
		}
		
		common.resize();
	}
	checkLogedIn(page){
		console.log("check login:", setting.isLogin, setting.isEntried);
		if(page === "collection"){
			
		}else if(page === "report"){
			
		}
	}
}